export const PRIMARY_INCOME_OPTIONS = [
    {
        value: 'W-2 Employee (Standard Paystubs / Full Time VOE)',
        label: 'W-2 Employee (Standard Paystubs / Full Time VOE)',
        category: 'QM',
        documentationType: 'FullDoc',
    },
    {
        value: 'Self-Employed: Full Documentation (Tax Returns)',
        label: 'Self-Employed: Full Documentation (Tax Returns)',
        category: 'QM',
        documentationType: 'FullDoc',
    },
    {
        value: 'Self-Employed: Bank Statements (Business or Personal accounts)',
        label: 'Self-Employed: Bank Statements (Business or Personal accounts)',
        category: 'Non-QM',
        documentationType: 'BusinessBankStatement12Mo',
    },
    {
        value: '1099 Contractor (Contractor income)',
        label: '1099 Contractor (Contractor income)',
        category: 'Non-QM',
        documentationType: 'Form109912Mo',
    },
    {
        value: 'Profit & Loss Statement (CPA Prepared 1 or 2 year)',
        label: 'Profit & Loss Statement (CPA Prepared 1 or 2 year)',
        category: 'Non-QM',
        documentationType: 'PL12',
    },
    {
        value: "Rental Property's Cash Flow (DSCR Loan)",
        label: "Rental Property's Cash Flow (DSCR Loan)",
        category: 'Non-QM',
        documentationType: 'DebtServiceCoverageRatio',
    },
    {
        value: 'High Net Worth / Asset Based (Savings, Stocks, Crypto)',
        label: 'High Net Worth / Asset Based (Savings, Stocks, Crypto)',
        category: 'Non-QM',
        documentationType: 'AssetQualifier',
        documentationTypes: ['AssetUtilization', 'AssetQualifier'],
    },
]

export const DEFAULT_QM_PRIMARY_INCOME = PRIMARY_INCOME_OPTIONS[0].value
export const DEFAULT_NON_QM_PRIMARY_INCOME = PRIMARY_INCOME_OPTIONS.find(
    (option) => option.category === 'Non-QM'
).value

export function getPrimaryIncomeOption(primaryIncome) {
    return PRIMARY_INCOME_OPTIONS.find(
        ({ value }) => value === primaryIncome
    )
}

export function getPrimaryIncomeDocumentationTypes(option) {
    if (!option) return []
    return [...(option.documentationTypes || [option.documentationType])]
}
